"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
var react_1 = __importStar(require("react"));
var HeaderSlider_1 = require("../../components/headerSlider/HeaderSlider");
var Loader_1 = require("../../components/loader/Loader");
// import { InStock } from '../../components/inStock/InStock';
// import { Promotion } from '../../components/promotion/Promotion';
// import { LastArrivals } from '../../components/lastArrivals/LastArrivals';
// import { PopularCars } from '../../components/popularCars/PopularCars';
var InStock = SuspenseLoader(function () { return Promise.resolve().then(function () { return __importStar(require('../../components/inStock/InStock')); }); });
var LastArrivals = SuspenseLoader(function () { return Promise.resolve().then(function () { return __importStar(require('../../components/lastArrivals/LastArrivals')); }); });
var Promotion = SuspenseLoader(function () { return Promise.resolve().then(function () { return __importStar(require('../../components/promotion/Promotion')); }); });
function SuspenseLoader(loader) {
    var Component = react_1.default.lazy(loader);
    return function (props) { return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.Loader, null) },
        react_1.default.createElement(Component, __assign({}, props)))); };
}
var Home = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderSlider_1.HeaderSlider, null),
        react_1.default.createElement(InStock, null),
        react_1.default.createElement(LastArrivals, null),
        react_1.default.createElement(Promotion, null)));
};
exports.Home = Home;
